import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        question: '=',
        form: '=',
        counter: '=',
        answeredQuestions: '='
    },
    template: `
        <h3 ng-bind-html="vm.questionName | isRequired: vm.question.formQuestions[0].isRequired"></h3>
        <textarea
            ng-model="vm.form.answers[vm.index].answerText"
            ng-keyup="vm.change()"
            class="form-control"
        ></textarea>
    `
})
export default class {
    constructor (lodash, FormSubmissionService) {
        this.submittedAnswerId = lodash.get(this.question, 'submittedAnswer.id', null);
        this.submittedAnswerText = lodash.get(this.question, 'submittedAnswer.answerText', null);
        this.answer = {
            id: this.submittedAnswerId,
            questionId: this.question.id,
            language: this.form.language,
            answerText: this.submittedAnswerText
        };

        this.answered = false;

        this.index = FormSubmissionService.registerAnswer(this.form.answers, this.answer);
    }

    $onInit () {
        this.questionName = `${this.counter}. ${this.question.activeI18n.name}`;
        if (this.submittedAnswerId && this.submittedAnswerText) {
            this.answeredQuestions = this.answeredQuestions + 1;
        }
    }

    change () {
        if (this.form.answers[this.index].answerText && !this.answered) {
            this.answeredQuestions = this.answeredQuestions + 1;
            this.answered = true;
        }
        else if (this.answered && !this.form.answers[this.index].answerText) {
            this.answeredQuestions = this.answeredQuestions - 1;
            this.answered = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/public/evaluation/question/freeText/index.js